module.exports = __webpack_public_path__ + "img/distribute-banner.723df394.png";